import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconTrendingStyle0 = gravityIconIndividualCss;

const GravityIconTrending = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '126a520e5353a2bd5dab059085552f2e0315057c', color: this.color, size: this.size }, h("svg", { key: '95614a50437a407ee5811855faf05bad11a045b8', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'ca61040d0f9b8e202c4afda3f1ecbf7369e87144', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m12.995 10.066 2.496 2.496a.3.3 0 0 0 .509-.213V6.297A.29.29 0 0 0 15.703 6H9.65a.3.3 0 0 0-.212.509l2.496 2.496-6.717 6.717a.5.5 0 0 0 0 .707l.353.354a.5.5 0 0 0 .707 0l6.718-6.718Z", fill: "currentColor" }))));
    }
};
GravityIconTrending.style = GravityIconTrendingStyle0;

export { GravityIconTrending as gravity_icon_trending };

//# sourceMappingURL=gravity-icon-trending.entry.js.map